var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"base-photo",class:`base-photo--${_vm.view}`,attrs:{"src":_vm.mutableSrc,"srcset":_vm.mutableSrcset,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }